/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminSocietyFormTaskTasksInner
 */
export interface AdminSocietyFormTaskTasksInner {
    /**
     * 
     * @type {string}
     * @memberof AdminSocietyFormTaskTasksInner
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSocietyFormTaskTasksInner
     */
    societyForm: string;
    /**
     * 
     * @type {number}
     * @memberof AdminSocietyFormTaskTasksInner
     */
    user: number;
    /**
     * 
     * @type {string}
     * @memberof AdminSocietyFormTaskTasksInner
     */
    readonly status?: string;
}

/**
 * Check if a given object implements the AdminSocietyFormTaskTasksInner interface.
 */
export function instanceOfAdminSocietyFormTaskTasksInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "societyForm" in value;
    isInstance = isInstance && "user" in value;

    return isInstance;
}

export function AdminSocietyFormTaskTasksInnerFromJSON(json: any): AdminSocietyFormTaskTasksInner {
    return AdminSocietyFormTaskTasksInnerFromJSONTyped(json, false);
}

export function AdminSocietyFormTaskTasksInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminSocietyFormTaskTasksInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'societyForm': json['society_form'],
        'user': json['user'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function AdminSocietyFormTaskTasksInnerToJSON(value?: AdminSocietyFormTaskTasksInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'society_form': value.societyForm,
        'user': value.user,
    };
}

